<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import MultiSelect from '@/components/form/MultiSelect.vue'

/** Whom with whom a connection role connects (D-202): what the other is to this one, by their kinds; none: every pair. */
defineProps({ modelValue: { type: Array, default: () => [] }, row: { type: Object, default: null }, context: { type: Object, default: null }, disabled: Boolean })
const emit = defineEmits(['update:modelValue'])
const { t } = useI18n()
const PAIRS = ['contact>contact', 'contact>account', 'account>contact', 'account>account']
const options = computed(() => PAIRS.map((p) => ({ value: p, label: t(`dictionaries.pairOptions.${p}`) })))
</script>

<template>
  <MultiSelect :model-value="modelValue || []" :options="options" :disabled="disabled" @update:model-value="(v) => emit('update:modelValue', v)" />
</template>
